module.exports = __webpack_public_path__ + "img/uv.151067d9.svg";